<template>
  <Header />
  <div :class="$style.container">
    <div :class="$style.content">
      <Filters />
      <Headers />
      <List />
      <Pagination />
    </div>
  </div>
  <SoundAlertModal v-if="$store.state.notifications.isLoad" />
</template>

<script>
import Header from "@/components/layouts/Header.vue";
import Filters from "@/components/events/Filters.vue";
import Headers from "@/components/events/Headers.vue";
import List from "@/components/events/List.vue";
import Pagination from "@/components/events/Pagination.vue";
import SoundAlertModal from "@/components/modals/SoundAlertModal.vue";
export default {
  components: {
    Header,
    Filters,
    Headers,
    List,
    Pagination,
    SoundAlertModal,
  },
  async mounted() {
    await this.$store.dispatch("getEvents", {});
  },
};
</script>

<style lang="scss" module>
.container {
  padding: 1.5rem;
  .content {
    background-color: $bg-secondary;
    border-radius: 1rem;
  }
}
</style>
